var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide-content-placeholder"},[_c(_vm.SlideContentComponents[_vm.slideActive.type],{tag:"component",staticClass:"flex vertical layout slide-content--wrapper animate__animated",class:{
      'contentFadeInLeft': _vm.$store.state.transitionContent == 'left',
      'contentFadeInRight': _vm.$store.state.transitionContent == 'right'
    },attrs:{"id":"slide-content--wrapper","slideActive":_vm.slideActive,"presentation":_vm.presentation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }